import React from 'react'
import './UponHeader.css'

import {
    BsTwitterX,
    BsInstagram,
    BsYoutube
} from 'react-icons/bs';

import {
    FaFacebookF,
    FaLinkedinIn,
    FaTiktok,
    FaFlickr,
    FaRegUser
} from 'react-icons/fa';

export const socialLinks = [
    { href: 'https://www.youtube.com/channel/UC6hHKx0z0enl5RnKnrOrmfw', label: 'youtube', icon: <BsYoutube /> },
    { href: 'https://www.instagram.com/ffttofficiel/', label: 'instagram', icon: <BsInstagram /> },
    { href: 'https://www.facebook.com/FFTTofficiel/?ref=hl#', label: 'facebook', icon: <FaFacebookF /> },
    { href: 'https://x.com/ffttofficiel', label: 'x', icon: <BsTwitterX /> },
    { href: 'https://fr.linkedin.com/company/federation-francaise-tennis-de-table', label: 'linkedin', icon: <FaLinkedinIn /> },
    { href: 'https://www.tiktok.com/@fftt_officiel', label: 'tiktok', icon: <FaTiktok /> },
    { href: 'https://www.flickr.com/photos/ffttofficiel/', label: 'flickr', icon: <FaFlickr /> },
]

function UponHeader() {
    return (
        <div className="upon-header">
            <div className="upon-header_wrapper">
                <nav className="upon-header_nav">
                    <a className="upon-header_btn tertiary" href="https://boutiquefftt.com/" target="_blank" rel="noreferrer">Boutique</a>
                    <a className="upon-header_btn link" href="https://www.fftt.com/presse/" target="_blank" rel="noreferrer">Presse</a>
                    <a className="upon-header_btn tertiary" href="https://www.fftt.com/application-fftt/" target="_blank" rel="noreferrer">Appli FFTT</a>
                    <a className="upon-header_btn link" href="https://fondationjacquessecretin.sportetfondations.fr/" target="_blank" rel="noreferrer">Fondation</a>
                    <a className="upon-header_btn red" href="https://www.fftt.com/je-signale/" target="_blank" rel="noreferrer">Je signale</a>
                </nav>
                <ul className="upon-header_social">
                    {
                        socialLinks.map((item) => (
                            <li key={item.label}>
                                <a href={item.href} target="_blank" rel="noreferrer" aria-label={item.label}>
                                    {item.icon}
                                </a>
                            </li>
                        ))
                    }
                </ul>
            </div>
            <a className="upon-header_account" href="https://malicence.fftt.com/login/" target="_blank" rel="noreferrer">
                <FaRegUser className="upon-header_btn-icon" />
                Mon compte FFTT
            </a>
        </div>
    );
}

export default UponHeader;
